import { render, staticRenderFns } from "./ListProduct.vue?vue&type=template&id=0478f6ec&scoped=true&"
import script from "./ListProduct.vue?vue&type=script&lang=js&"
export * from "./ListProduct.vue?vue&type=script&lang=js&"
import style0 from "./ListProduct.vue?vue&type=style&index=0&id=0478f6ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0478f6ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRow,VSimpleCheckbox,VTooltip})
